import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  toggle() {
    if (this.menuTarget.classList.contains("translate-x-full")) {
      this.menuTarget.classList.remove("translate-x-full", "hidden")
      this.menuTarget.classList.add("translate-x-0")
    } else {
      this.menuTarget.classList.remove("translate-x-0")
      this.menuTarget.classList.add("translate-x-full")
    }
  }

  // Close the menu when clicking outside
  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.menuTarget.classList.remove("translate-x-0")
      this.menuTarget.classList.add("translate-x-full")
    }
  }

  connect() {
    document.addEventListener("click", this.clickOutside.bind(this))
  }

  disconnect() {
    document.removeEventListener("click", this.clickOutside.bind(this))
  }
} 